/* MotoWing: ürün karşılaştırma sayfası (sections/mw-compare, /pages/karsilastir). Listedeki ürünler (window.mwCmp, assets/motowing-compare.js) /products/{handle}?view=mw-cmp verisiyle yan yana tablo: fiyat (en uygunu işaretli), Sepete ekle / Seçenek seç (ortak hızlı ekleme kodu), kargo ücreti, kargoya veriliş, garajdaki motora uyum, uyumlu marka/model, stok, seçenekler, ürün türü, açıklamadaki "Etiket: değer" özellikleri; sadece farklar, ürün çıkar, temizle, paylaş (?u=…), arayarak ekleme (/search/suggest.json). */
(function(){
  var P=document.querySelector('[data-mw-cmp-page]'), C=window.mwCmp; if(!P||!C||P.mwI) return; P.mwI=1;
  var R=((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/').replace(/\/$/,'')+'/', MAX=C.MAX, PAGE=C.PAGE, FMT=window.mwFMT||'{{amount_with_comma_separator}} TL';
  var get=C.get, set=C.set, add=C.add, remove=C.remove, clear=C.clear;
  var XI='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg>';
  function idx(a,h){ for(var i=0;a.length>i;i++){ if(a[i].h===h) return i; } return -1; }
  function el(t,c,x){ var e=document.createElement(t); if(c) e.className=c; if(x!=null) e.textContent=x; return e; }
    var tbl=P.querySelector('[data-mw-cmp-tbl]'), empty=P.querySelector('[data-mw-cmp-empty]'), tools=P.querySelector('[data-mw-cmp-tools]'), subEl=P.querySelector('[data-mw-cmp-sub]');
    var diff=P.querySelector('[data-mw-cmp-diff]'), q=P.querySelector('[data-mw-cmp-q]'), res=P.querySelector('[data-mw-cmp-res]'), motoEl=P.querySelector('[data-mw-cmp-moto]');
    var moto=null; try{ moto=JSON.parse(localStorage.getItem('mw_moto')||'null'); if(!moto||!moto.b) moto=null; }catch(e){}
    if(moto&&moto.m&&motoEl){ motoEl.innerHTML='Garajındaki motor: <b></b> · uyum satırı buna göre. <a href="'+R+'pages/garajim">Değiştir</a>'; motoEl.querySelector('b').textContent=moto.b+' '+moto.m; motoEl.hidden=false; }
    /* paylaşılan link: ?u=a,b */
    try{
      var u=new URLSearchParams(location.search).get('u');
      if(u){ var a0=get(); u.split(',').forEach(function(h){ h=h.trim(); if(h&&idx(a0,h)<0&&MAX>a0.length) a0.push({h:h}); }); set(a0,true); }
    }catch(e){}
    var cache={}, tok=0;
    function load(h){
      if(!cache[h]) cache[h]=fetch(R+'products/'+encodeURIComponent(h)+'?view=mw-cmp',{credentials:'same-origin'}).then(function(r){ if(!r.ok) throw r.status; return r.json(); }).catch(function(e){ delete cache[h]; throw e; });
      return cache[h];
    }
    function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
    function num(c,d,t,s){ var p=(c/100).toFixed(d).split('.'); p[0]=p[0].replace(/\B(?=(\d{3})+(?!\d))/g,t); return p[1]?p[0]+s+p[1]:p[0]; }
    function money(c){
      var m=FMT.match(/\{\{\s*(\w+)\s*\}\}/); if(!m) return num(c,2,'.',',')+' TL';
      var v={amount:num(c,2,',','.'),amount_no_decimals:num(c,0,',','.'),amount_with_comma_separator:num(c,2,'.',','),amount_no_decimals_with_comma_separator:num(c,0,'.',','),amount_with_space_separator:num(c,2,' ',','),amount_with_period_and_space_separator:num(c,2,' ','.'),amount_with_apostrophe_separator:num(c,2,"'",'.')}[m[1]];
      return FMT.replace(m[0],v||num(c,2,',','.')).replace(/<[^>]*>/g,'');
    }
    function hasv(a,v){ if(!Array.isArray(a)) return false; v=String(v).toLowerCase(); for(var i=0;a.length>i;i++){ if(String(a[i]).toLowerCase()===v) return true; } return false; }
    var SHIP=(function(){
      try{
        var H=['01-01','04-23','05-01','05-19','07-15','08-30','10-29'], D=['Pazar','Pazartesi','Salı','Çarşamba','Perşembe','Cuma','Cumartesi'];
        var t=new Date(Date.now()+108e5), d=new Date(t.getUTCFullYear(),t.getUTCMonth(),t.getUTCDate());
        for(var i=1;15>i;i++){ var n=new Date(d.getFullYear(),d.getMonth(),d.getDate()+i), w=n.getDay(), k=('0'+(n.getMonth()+1)).slice(-2)+'-'+('0'+n.getDate()).slice(-2); if((w===1||w===3||w===5)&&H.indexOf(k)<0) return i===1?'Yarın':D[w]; }
      }catch(e){}
      return '';
    })();
    function specs(html){
      var out=[]; if(!html||!window.DOMParser) return out;
      try{
        var d=new DOMParser().parseFromString(html,'text/html');
        [].forEach.call(d.querySelectorAll('li'),function(li){
          var s=li.querySelector('strong,b'); if(!s) return;
          var st=s.textContent.trim(), lb=st.replace(/\s*[:：]\s*$/,'').trim(); if(!lb||lb.length>40||st===li.textContent.trim()&&!/[:：]/.test(st)) return;
          var full=li.textContent.replace(/\s+/g,' ').trim(), at=full.indexOf(st), val=(at>-1?full.slice(at+st.length):'').replace(/^\s*[:：\-–]\s*/,'').trim();
          if(!val||/^uyumlu\s+(marka|model)/i.test(lb)) return;
          out.push([lb,val]);
        });
      }catch(e){}
      return out;
    }
    function chips(a){ if(!Array.isArray(a)||!a.length) return '<span class="mw-cmp__mut">—</span>'; return '<span class="mw-cmp__chips">'+a.map(function(x){ return '<span>'+esc(x)+'</span>'; }).join('')+'</span>'; }
    function cPrice(p,min,var_){
      var s='<b class="mw-cmp__pr">'+esc(money(p.p))+'</b>';
      if(p.pm>p.p) s+='<small class="mw-cmp__mut"> – '+esc(money(p.pm))+'</small>';
      if(p.c>p.p) s+='<span class="mw-cmp__was"><s>'+esc(money(p.c))+'</s><i>%'+Math.round((p.c-p.p)*100/p.c)+'</i></span>';
      if(var_&&p.p===min) s+='<span class="mw-cmp__best">En uygun fiyat</span>';
      return s;
    }
    function cCta(p){
      if(p.x===2) return '<a class="mw-cmp__btn is-r" href="'+esc(p.u)+'">İncele</a>';
      if(!p.a) return '<span class="mw-cmp__btn is-dis">Tükendi</span>';
      if(p.v) return '<button type="button" class="mw-cmp__btn is-r" data-mw-qa="'+p.v+'" data-url="'+esc(p.u)+'" aria-label="Sepete ekle: '+esc(p.t)+'"><span class="mw-cmp__a1">Sepete ekle</span><span class="mw-cmp__a2">Sepete eklendi</span></button>';
      return '<button type="button" class="mw-cmp__btn is-r" data-mw-qo="'+esc(p.h)+'" data-url="'+esc(p.u)+'" aria-label="Seçenek seç: '+esc(p.t)+'">Seçenek seç</button>';
    }
    function cKargo(p){
      if(p.x===2) return 'Mağazaya sor';
      if(p.x===1) return '10.500 TL <small class="mw-cmp__mut">ithal ürün</small>';
      if(p.p>=700000) return '<b class="is-g">Ücretsiz</b>';
      return '400 TL <small class="mw-cmp__mut">sepet 7.000 TL\'yi geçince ücretsiz</small>';
    }
    function cShip(p){ if(p.x===2) return '<span class="mw-cmp__mut">—</span>'; if(p.x===1) return 'Açıklamada belirtilir'; if(!p.a) return 'Stokta yok'; return SHIP?'<b>'+SHIP+'</b> kargoda':'Pzt · Çar · Cuma'; }
    function cFit(p){
      if(hasv(p.k,moto.b)&&hasv(p.m,moto.m)) return '<b class="is-g">✓ Uyumlu</b>';
      if(hasv(p.k,'Universal')||hasv(p.m,'Universal')) return 'Universal';
      if(!(p.k&&p.k.length)&&!(p.m&&p.m.length)) return '<span class="mw-cmp__mut">Bilgi yok</span>';
      return '<span class="is-r">✕ Listede yok</span>';
    }
    function cOpt(p){ if(!(p.vc>1)||!p.o||!p.o.length) return 'Tek seçenek'; return p.o.map(function(o){ return '<span class="mw-cmp__mut">'+esc(o.n)+':</span> '+esc((o.v||[]).join(', ')); }).join('<br>'); }
    function draw(ps){
      var n=ps.length, slot=MAX>n;
      if(!n){ show0(); return; }
      subEl.textContent=n<2?'Karşılaştırmak için en az bir ürün daha ekle.':n+' ürün yan yana';
      var min=Math.min.apply(null,ps.map(function(p){ return p.p; })), vary=ps.some(function(p){ return p.p!==min; });
      var rows=[
        {l:'Fiyat',c:ps.map(function(p){ return cPrice(p,min,vary); })},
        {l:'',c:ps.map(cCta),keep:1,cls:'is-cta'},
        {l:'Kargo ücreti',c:ps.map(cKargo)},
        {l:'Kargoya veriliş',c:ps.map(cShip)}
      ];
      if(moto&&moto.m) rows.push({l:moto.b+' '+moto.m+' uyumu',c:ps.map(cFit)});
      rows.push({l:'Uyumlu markalar',c:ps.map(function(p){ return chips(p.k); })});
      rows.push({l:'Uyumlu modeller',c:ps.map(function(p){ return chips(p.m); })});
      rows.push({l:'Stok',c:ps.map(function(p){ return p.a?'<b class="is-g">Stokta</b>':'<span class="is-r">Tükendi</span>'; })});
      rows.push({l:'Seçenekler',c:ps.map(cOpt)});
      rows.push({l:'Ürün türü',c:ps.map(function(p){ return p.ty?esc(p.ty):'<span class="mw-cmp__mut">—</span>'; })});
      var S=ps.map(function(p){ return specs(p.d); }), keys=[], lab={};
      S.forEach(function(sp){ sp.forEach(function(x){ var k=x[0].toLowerCase(); if(!lab[k]){ lab[k]=x[0]; keys.push(k); } }); });
      keys.slice(0,14).forEach(function(k){ rows.push({l:lab[k],c:S.map(function(sp){ for(var i=0;sp.length>i;i++){ if(sp[i][0].toLowerCase()===k) return esc(sp[i][1]); } return '<span class="mw-cmp__mut">—</span>'; })}); });
      var h='<div class="mw-cmp__sc"><div class="mw-cmp__grid" style="--c:'+n+';--cs:'+(n+(slot?1:0))+'">';
      h+='<div class="mw-cmp__row is-head"><div class="mw-cmp__lab"><span></span></div>';
      ps.forEach(function(p){
        h+='<div class="mw-cmp__cell is-prod"><button type="button" class="mw-cmp__rm" data-rm="'+esc(p.h)+'" aria-label="Listeden çıkar: '+esc(p.t)+'">'+XI+'</button><a class="mw-cmp__pi" href="'+esc(p.u)+'">'+(p.i?'<img src="'+esc(p.i)+'" alt="" width="240" height="240" loading="lazy">':'')+'</a><a class="mw-cmp__pt" href="'+esc(p.u)+'">'+esc(p.t)+'</a></div>';
      });
      if(slot) h+='<div class="mw-cmp__cell is-slot"><button type="button" data-cp-focus>'+'<b>+</b>Ürün ekle<small>En fazla '+MAX+' ürün</small></button></div>';
      h+='</div>';
      rows.forEach(function(r){
        var same=!r.keep&&n>1&&r.c.every(function(x){ return x.replace(/<[^>]*>/g,'').trim()===r.c[0].replace(/<[^>]*>/g,'').trim(); });
        h+='<div class="mw-cmp__row'+(r.cls?' '+r.cls:'')+'"'+(same?' data-same':'')+'><div class="mw-cmp__lab"><span>'+esc(r.l)+'</span></div>';
        r.c.forEach(function(x){ h+='<div class="mw-cmp__cell">'+x+'</div>'; });
        if(slot) h+='<div class="mw-cmp__cell is-slot" aria-hidden="true"><span></span></div>';
        h+='</div>';
      });
      h+='</div></div>';
      tbl.innerHTML=h; empty.hidden=true; tools.hidden=false;
    }
    function show0(){ tbl.innerHTML=''; empty.hidden=false; tools.hidden=true; subEl.textContent='En fazla '+MAX+' ürünü yan yana karşılaştır.'; }
    function render(){
      var a=get(), my=++tok;
      if(!a.length){ show0(); return; }
      if(!tbl.firstChild) tbl.innerHTML='<div class="mw-cmp__ld" role="status" aria-label="Yükleniyor"><span></span><span></span><span></span></div>';
      Promise.all(a.map(function(x){ return load(x.h).then(function(d){ return d; },function(){ return null; }); })).then(function(list){
        if(my!==tok) return;
        var ps=list.filter(function(d){ return d&&d.h; });
        var nb=get().map(function(x){ for(var i=0;ps.length>i;i++){ if(ps[i].h===x.h) return {h:x.h,t:ps[i].t,i:ps[i].i}; } return null; }).filter(Boolean);
        set(nb,true);
        draw(ps);
      });
    }
    document.addEventListener('mw:cmp',render);
    P.addEventListener('click',function(e){
      var r=e.target.closest('[data-rm]'); if(r){ remove(r.getAttribute('data-rm')); return; }
      if(e.target.closest('[data-cp-focus]')){ q.focus(); q.scrollIntoView({block:'center',behavior:'smooth'}); return; }
      if(e.target.closest('[data-mw-cmp-clear]')){ clear(); return; }
      var sh=e.target.closest('[data-mw-cmp-share]');
      if(sh){
        var url=location.origin+PAGE+'?u='+get().map(function(x){ return encodeURIComponent(x.h); }).join(',');
        if(navigator.share&&window.matchMedia('(pointer:coarse)').matches){ navigator.share({title:'Ürün karşılaştırma · MotoWing',url:url}).catch(function(){}); return; }
        var done=function(){ sh.textContent='Bağlantı kopyalandı ✓'; setTimeout(function(){ sh.textContent='Bağlantıyı paylaş'; },2200); };
        if(navigator.clipboard) navigator.clipboard.writeText(url).then(done,function(){ prompt('Bağlantı',url); }); else prompt('Bağlantı',url);
      }
    });
    diff.addEventListener('change',function(){ P.classList.toggle('is-diff',diff.checked); });
    /* arayarak ekle */
    var st=0, items=[], cur=-1, qt=0;
    function closeRes(){ res.hidden=true; q.setAttribute('aria-expanded','false'); cur=-1; }
    function pick(i){
      var p=items[i]; if(!p) return;
      if(add({h:p.handle,t:p.title,i:p.image})) q.value='';
      closeRes();
    }
    function hl(){ [].forEach.call(res.children,function(li,i){ li.classList.toggle('is-on',i===cur); li.setAttribute('aria-selected',i===cur?'true':'false'); }); }
    q.addEventListener('input',function(){
      clearTimeout(st); var v=q.value.trim(); if(v.length<2){ closeRes(); return; }
      st=setTimeout(function(){
        var my=++qt;
        fetch(R+'search/suggest.json?q='+encodeURIComponent(v)+'&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last',{credentials:'same-origin'})
          .then(function(r){ return r.json(); })
          .then(function(j){
            if(my!==qt) return;
            items=((j&&j.resources&&j.resources.results&&j.resources.results.products)||[]).map(function(p){ return {handle:p.handle,title:p.title,image:p.image||(p.featured_image&&p.featured_image.url)||'',price:p.price}; });
            res.innerHTML='';
            if(!items.length){ var e0=el('li','is-empty','Sonuç bulunamadı'); res.appendChild(e0); }
            var a=get();
            items.forEach(function(p,i){
              var li=el('li'); li.setAttribute('role','option'); li.id='mw-cmp-o'+i; li.setAttribute('data-i',i);
              if(p.image){ var im=new Image(); im.src=p.image+(p.image.indexOf('?')>-1?'&':'?')+'width=96'; im.alt=''; im.width=48; im.height=48; li.appendChild(im); }
              var tx=el('span','mw-cmp__rt'); tx.appendChild(el('b','',p.title));
              var pr=parseFloat(p.price); if(!isNaN(pr)) tx.appendChild(el('small','',money(Math.round(pr*100))));
              li.appendChild(tx);
              li.appendChild(el('em','',idx(a,p.handle)>-1?'Listede':'Ekle'));
              res.appendChild(li);
            });
            res.hidden=false; q.setAttribute('aria-expanded','true'); cur=-1;
          }).catch(function(){ closeRes(); });
      },220);
    });
    q.addEventListener('keydown',function(e){
      if(res.hidden) return;
      if(e.key==='ArrowDown'){ e.preventDefault(); cur=Math.min(items.length-1,cur+1); hl(); }
      else if(e.key==='ArrowUp'){ e.preventDefault(); cur=Math.max(0,cur-1); hl(); }
      else if(e.key==='Enter'){ e.preventDefault(); pick(cur>-1?cur:0); }
      else if(e.key==='Escape'){ closeRes(); }
    });
    res.addEventListener('mousedown',function(e){ e.preventDefault(); });
    res.addEventListener('click',function(e){ var li=e.target.closest('li[data-i]'); if(li) pick(+li.getAttribute('data-i')); });
    document.addEventListener('click',function(e){ if(!e.target.closest('.mw-cmp__aw')) closeRes(); });
    render();
})();